import store from '@/store'
import router from '@/router'
import auditStatus from '@/constants/auditStatus'
import { getIdPass } from '@/util/register/getAuditPass'

const redirect = {
  async redirectToIbPortal(methodsOptions = null) {
    const isCompleted = getIdPass(
      store.state.common.poiAuditStatus,
      store.state.common.ibtPoiAuditStatus,
      store.state.common.id3Pass
    )
    const isSubmitted = +store.state.common.poiAuditStatus === auditStatus.submitted

    if (!isCompleted) {
      await store.dispatch('common/actionPoiAuditStatus')
      isSubmitted ? methodsOptions.submitted() : router.push('/register')
      return
    }

    const url = process.env.NODE_ENV == 'development' ? 'http://localhost:8085/' : store.state.common.url
    if (url) {
      try {
        const userStore = store.state.common
        window.location = `${url}?accessToken=${userStore.accessToken}`
      } catch (error) {
        console.log(error)
      }
    }
  },
  redirectToLogoutUrl(url = '') {
    window.location = `${window.location.origin}/login${url}`
  },
}

export default redirect
